import { useState } from "react";
import { Header } from "@/components/Header";
import { useLanguage } from "@/context/LanguageContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { OrderQueue } from "@/components/staff/OrderQueue";
import { MenuManager } from "@/components/staff/MenuManager";
import { Analytics } from "@/components/staff/Analytics";
import { TablesQR } from "@/components/staff/TablesQR";
import { Customers } from "@/components/staff/Customers";
import { Button } from "@/components/ui/button";
import { ClipboardList, UtensilsCrossed, BarChart3, QrCode, Eye, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { RadioPlayer } from "@/components/staff/RadioPlayer";

export default function StaffDashboard() {
  const { t } = useLanguage();
  const [tab, setTab] = useState("queue");

  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="staff-dashboard">
      <Header />
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight text-[#4A2C2A]">
            {t("staff_dashboard")}
          </h1>
          <div className="flex items-center gap-2 flex-wrap">
            <RadioPlayer />
            <Link to="/menu">
              <Button data-testid="customer-view-link" variant="outline" size="sm" className="gap-1.5 rounded-full border-[#E8DFD5] text-[#4A2C2A]">
                <Eye className="w-4 h-4" /> {t("customer_view")}
              </Button>
            </Link>
          </div>
        </div>
        <Tabs value={tab} onValueChange={setTab} className="mt-5">
          <TabsList className="bg-[#F6F1E9] border border-[#E8DFD5] flex-wrap h-auto">
            <TabsTrigger data-testid="tab-queue" value="queue" className="gap-1.5">
              <ClipboardList className="w-4 h-4" /> {t("queue")}
            </TabsTrigger>
            <TabsTrigger data-testid="tab-menu-mgmt" value="menu" className="gap-1.5">
              <UtensilsCrossed className="w-4 h-4" /> {t("menu_mgmt")}
            </TabsTrigger>
            <TabsTrigger data-testid="tab-analytics" value="analytics" className="gap-1.5">
              <BarChart3 className="w-4 h-4" /> {t("analytics")}
            </TabsTrigger>
            <TabsTrigger data-testid="tab-customers" value="customers" className="gap-1.5">
              <Users className="w-4 h-4" /> {t("customers")}
            </TabsTrigger>
            <TabsTrigger data-testid="tab-tables" value="tables" className="gap-1.5">
              <QrCode className="w-4 h-4" /> {t("tables_qr")}
            </TabsTrigger>
          </TabsList>
          <TabsContent value="queue" className="mt-6"><OrderQueue /></TabsContent>
          <TabsContent value="menu" className="mt-6"><MenuManager /></TabsContent>
          <TabsContent value="analytics" className="mt-6"><Analytics /></TabsContent>
          <TabsContent value="customers" className="mt-6"><Customers /></TabsContent>
          <TabsContent value="tables" className="mt-6"><TablesQR /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
